export const FIXED_COMMA_SEPARATED = 'FIXED_COMMA_SEPARATED'
export const IS_EMPTY = 'IS_EMPTY'
export const IS_DEFAULT = 'IS_DEFAULT'
export const PRODUCT_PRICE = 'PRODUCT_PRICE'
export const PRODUCT_FIELD = 'PRODUCT_FIELD'
export const PRODUCT_FEATURE = 'PRODUCT_FEATURE'
export const SPECIFIC = 'SPECIFIC'
export const MODEL_TEMPLATE = 'MODEL_TEMPLATE'
export const NAME_TEMPLATE = 'NAME'
export const EXTERNAL = 'EXTERNAL'
export const USER_FORMAT_SKU = 'USER_FORMAT_SKU'